/**
 * Helpers for the per-edge filter list on Architectural Hierarchy nodes.
 *
 * Schema: each tree node has `filters: Array<{ id, type, value }>` where
 *   type is 'jql' or 'expression' and value is the raw user-authored
 *   JQL / Jira-expression string. Both empty by default.
 *
 * Multiple filters of the same type are combined with AND (for JQL) or
 * `&&` (for Jira expressions) so admins can stack rules incrementally
 * — e.g. "add a status filter, then add an assignee filter, then add a
 * compare-priorities expression" — instead of editing one big string.
 */

export function migrateFiltersFromLegacy(node) {
  if (Array.isArray(node?.filters)) return node.filters;
  const out = [];
  if (node?.jqlFilter && String(node.jqlFilter).trim()) {
    out.push({ id: 'legacy-jql', type: 'jql', value: String(node.jqlFilter) });
  }
  if (node?.expression && String(node.expression).trim()) {
    out.push({ id: 'legacy-expr', type: 'expression', value: String(node.expression) });
  }
  return out;
}

export function combineJqlFilters(filters) {
  if (!Array.isArray(filters)) return '';
  const parts = filters
    .filter(f => f?.type === 'jql' && f?.value && String(f.value).trim())
    .map(f => `(${String(f.value).trim()})`);
  return parts.join(' AND ');
}

export function combineExpressions(filters) {
  if (!Array.isArray(filters)) return '';
  const parts = filters
    .filter(f => f?.type === 'expression' && f?.value && String(f.value).trim())
    .map(f => `(${String(f.value).trim()})`);
  return parts.join(' && ');
}
